module.exports = __webpack_public_path__ + "img/horizontal_6_4_pp2_8023.35e23288.png";